import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';

import { navigate } from 'gatsby-link';
import renderIcon from '../../../utils/renderIcon';

const ns = 'search-bar-unbxd';

const SearchBar = ({
	closeSearchFlyout = () => {},
	isSearchFlyout,
}) => {
	const [query, setQuery] = useState('');
	const inputRef = useRef();

	useEffect(() => {
		isSearchFlyout && setTimeout(() => inputRef.current?.focus({
			preventScroll: true,
		}), 100);
	}, [isSearchFlyout]);

	const reset = () => {
		setQuery('');
		inputRef.current?.focus({
			preventScroll: true,
		});
	};

	const handleSubmit = e => {
		e.preventDefault();
		closeSearchFlyout();
		navigate(
			`/search?q=${ query }`,
			{ replace: true }
		);
		// navigate(
		// 	`/search`,
		// 	{ replace: true, state: { query } }
		// );
	};

	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	return (
		<div className={rootClassnames}>
			<form
				role={`search`}
				action={`/search`}
				onSubmit={handleSubmit}
			>
				<input
					ref={inputRef}
					type={'text'}
					value={query}
					minLength={3}
					onChange={e => {
						setQuery(e.target.value);
					}}
					placeholder={`Search`}
				/>
				<button type={'reset'} onClick={reset}>clear</button>
				<button type={`submit`}>
					<span aria-hidden>
						{renderIcon('search')}
					</span>
					<span className={`visually-hidden`}>Search</span>
				</button>
			</form>
		</div>
	);
};

export default SearchBar;
